import { css } from '@emotion/css';

export const caption = css`
  background: rgba(0, 0, 0, 0.6);
`;

export const listViewResource = css`
  width: calc(50% - 0.5rem);
`;

export const listViewResourceMediumSize = css`
  width: 100%;
`;

export const leftArrowPosition = css`
  left: 2.4rem;
  margin-top: 0.4rem;
`;

export const rightArrowPosition = css`
  left: unset;
  right: -1.6rem;
  margin-top: 0.4rem;
`;
